export default __webpack_public_path__ + "static/media/smartSyncIcon.d04c3460.svg";